var map = {
	"./3.png": 7211,
	"./4.png": 9501,
	"./Call.png": 6847,
	"./Emails.png": 5996,
	"./Finances.png": 4620,
	"./Icon10@2x.png": 7300,
	"./Icon10@3x.png": 4371,
	"./Icon1@2x.png": 7354,
	"./Icon1@3x.png": 5697,
	"./Icon2@2x.png": 2026,
	"./Icon2@3x.png": 5032,
	"./Icon3@2x.png": 7732,
	"./Icon3@3x.png": 5998,
	"./Icon4@2x.png": 1410,
	"./Icon4@3x.png": 3963,
	"./Icon5@2x.png": 8565,
	"./Icon5@3x.png": 8358,
	"./Icon6@2x.png": 8518,
	"./Icon6@3x.png": 7421,
	"./Icon7@2x.png": 4758,
	"./Icon7@3x.png": 8991,
	"./Icon8@2x.png": 8458,
	"./Icon8@3x.png": 4258,
	"./Icon9@2x.png": 1435,
	"./Icon9@3x.png": 4636,
	"./Meal.png": 7733,
	"./Programs.png": 9596,
	"./Reminder.png": 9063,
	"./To-do.png": 3686,
	"./Urgent.png": 688,
	"./blue-flag.png": 2858,
	"./dollar.png": 1843,
	"./food.png": 6070,
	"./green-flag.png": 6935,
	"./heart.png": 4879,
	"./items.png": 3377,
	"./mail.png": 9974,
	"./phone.png": 8456,
	"./red-flag.png": 7813,
	"./smiley.png": 6588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8686;